import { Component, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit, SimpleChanges } from '@angular/core';
import {  ModalRef } from "mis-crystal-design-system/modal";
@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

  @Input() fileToUpload: any;
  @Input() uploadFileError: any;
  @Input() showFileUploadModal: any;
  @Output() submitUploadReportCallback = new EventEmitter();
  @Output() handleDismissUploadFileModal = new EventEmitter();

  modalRef: ModalRef;

  constructor( ) { }

  ngOnInit() {
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if(changes.showFileUploadModal.currentValue === false) {
  //     this.modalRef.close();
  //   } else if(changes.showFileUploadModal.currentValue === true) {
  //     this.modalRef = this.modalSvc.show(
  //       DialogComponent,
  //       { titleText: "Uploading..." },
  //       { closeOnBackdropClick: false,  top: '290px', }
  //     );
  //   }
  // }

   handleSubmit() {
    if (this.submitUploadReportCallback) {
      this.submitUploadReportCallback.emit();
    }
  }

  handleClose() {
    if (this.handleDismissUploadFileModal) {
      this.handleDismissUploadFileModal.emit();
    }
  }
}
